__turbopack_context__.v({
  "container": "TextBlock-module__7b2ExG__container",
  "containerTerms": "TextBlock-module__7b2ExG__containerTerms",
  "content": "TextBlock-module__7b2ExG__content",
  "contentTerms": "TextBlock-module__7b2ExG__contentTerms",
  "fadeInItems": "TextBlock-module__7b2ExG__fadeInItems",
  "spacing--lg": "TextBlock-module__7b2ExG__spacing--lg",
  "spacing--md": "TextBlock-module__7b2ExG__spacing--md",
  "spacing--sm": "TextBlock-module__7b2ExG__spacing--sm",
  "spacing--xl": "TextBlock-module__7b2ExG__spacing--xl",
  "spacing--xs": "TextBlock-module__7b2ExG__spacing--xs",
  "spacing--xxl": "TextBlock-module__7b2ExG__spacing--xxl",
  "spacing--xxs": "TextBlock-module__7b2ExG__spacing--xxs",
  "spacing--xxxl": "TextBlock-module__7b2ExG__spacing--xxxl",
  "spacing--xxxs": "TextBlock-module__7b2ExG__spacing--xxxs",
});
